import React, { useRef } from "react";

const ImagePicker = ({
  file,
  previewUrl,
  onPick,
  onClear,
  scale = 100,
  onScaleChange,
  fit = "cover",
  onFitChange,
}) => {
  const inputRef = useRef(null);
  return (
    <div className="flex flex-wrap items-start gap-3">
      <div
        className="flex items-center justify-center overflow-hidden rounded-lg border border-gray-200 bg-gray-50"
        style={{
          width: `${Math.round(96 * (scale / 100))}px`,
          height: `${Math.round(96 * (scale / 100))}px`,
        }}>
        {previewUrl ? (
          <img
            src={previewUrl}
            alt="preview"
            className="h-full w-full"
            style={{ objectFit: fit }}
          />
        ) : (
          <span className="text-xs text-gray-400">No image</span>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => {
            const f = e.target.files && e.target.files[0];
            if (f) onPick(f);
          }}
        />
        <button
          type="button"
          onClick={() => inputRef.current && inputRef.current.click()}
          className="cursor-pointer rounded-lg border border-red-500 bg-red-500 px-2 py-2 text-white font-semibold hover:bg-red-600 transition-colors shadow-md">
          Choose Image
        </button>
        {previewUrl ? (
          <button
            type="button"
            onClick={onClear}
            className="cursor-pointer rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900">
            Remove
          </button>
        ) : null}
        {previewUrl ? (
          <>
            <div className="flex items-center gap-2">
              <label className="text-xs text-gray-500">Size</label>
              <input
                type="range"
                min={50}
                max={200}
                step={10}
                value={scale}
                onChange={(e) =>
                  onScaleChange && onScaleChange(Number(e.target.value))
                }
              />
              <span className="w-9 text-right text-xs text-gray-700">
                {scale}%
              </span>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-xs text-gray-500">Fit</label>
              <select
                value={fit}
                onChange={(e) => onFitChange && onFitChange(e.target.value)}
                className="rounded-md border border-gray-300 bg-white px-2 py-1">
                <option value="cover">Cover</option>
                <option value="contain">Contain</option>
                <option value="fill">Fill</option>
                <option value="none">None</option>
                <option value="scale-down">Scale down</option>
              </select>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ImagePicker;
